import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Moon, Sun } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import WelcomeHeader from './components/WelcomeHeader';
import LoginForm from './components/LoginForm';
import SecurityBadges from './components/SecurityBadges';
import ArtistSplashSlideshow from '../../components/ArtistSplashSlideshow';


const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { signIn, user, userProfile } = useAuth();
  const { theme, toggleTheme, isDark } = useTheme();

  // Redirect authenticated users to their dashboard
  useEffect(() => {
    if (user && userProfile) {
      const roleRoutes = {
        admin: '/admin-dashboard',
        editor: '/editor-dashboard',
        artist: '/artist-content-management'
      };
      
      const userRole = userProfile?.role;
      const redirectPath = roleRoutes?.[userRole] || '/admin-dashboard';
      navigate(redirectPath);
    }
  }, [user, userProfile, navigate]);

  // Don't show login form if user is already authenticated
  if (user && userProfile) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex">
      {/* Theme Toggle Button */}
      <button
        onClick={toggleTheme}
        className="fixed top-4 right-4 z-50 p-3 bg-card hover:bg-muted rounded-full shadow-lg elevation-2 transition-all duration-300 ease-in-out"
        aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        {isDark ? (
          <Sun className="w-5 h-5 text-warning" />
        ) : (
          <Moon className="w-5 h-5 text-text-primary" />
        )}
      </button>

      {/* Left Panel - Login Form */}
      <div className="flex-1 flex flex-col justify-center px-4 sm:px-6 lg:px-20 xl:px-24 bg-background">
        <div className="mx-auto w-full max-w-sm lg:w-96">
          <WelcomeHeader />
          
          <div className="mt-8">
            <LoginForm />
          </div>
          
          <SecurityBadges />
        </div>
      </div>

      {/* Right Panel - Artist Splash Slideshow - Enhanced for proper image display */}
      <div className="hidden lg:block relative flex-1 min-h-screen overflow-hidden bg-gradient-to-br from-purple-600 via-blue-600 to-indigo-800">
        <div className="absolute inset-0 w-full h-full">
          <ArtistSplashSlideshow />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;